import React, { useContext, useEffect, useState } from 'react'
import { appContext } from "../AppContext";
import { Tabs, Select } from 'antd';
import SkillWiki from '../components/character/wiki/SkillWiki';
import RaceWiki from '../components/character/wiki//RaceWiki';
import AgnoiaItemWiki from '../components/character/wiki/AgnoiaItemWiki';
import AgnoiaAlchemyWiki from '../components/character/wiki/AgnoiaAlchemyWiki';
import { IsAgnoia, IsStormvloed } from '../utils';
import { Mobile } from '../utils/mediaQuery';

const { TabPane } = Tabs;
const { Option } = Select;

export default function WikiPage() {

    const [appState, AppDispatch] = useContext(appContext);
    const isStormvloed = IsStormvloed(appState.storyName)
    const isAgnoia = IsAgnoia(appState.storyName)
    const [links, setLinks] = useState({})

    useEffect(() => {
        AppDispatch({ type: "SETSELECTEDPAGE", payload: "Wiki page" })
      }, // eslint-disable-next-line
      [])

      useEffect(() => {
        if(appState.configurations.length > 0) {
            const rulesConfig = appState.configurations.find(_ => _.name === "Links.Stormvloed.Rules")
            const larptomRulesConfig = appState.configurations.find(_ => _.name === "Links.Larptom.Rules")
            const otherDocumentsConfig = appState.configurations.find(_ => _.name === "Links.Stormvloed.OtherDocuments")
            
            const rulesAgnoiaConfig = appState.configurations.find(_ => _.name === "Links.Agnoia.Rules")
            const otherDocumentsAgnoiaConfig = appState.configurations.find(_ => _.name === "Links.Agnoia.OtherDocuments");

            const waAgnoia = appState.configurations.find(_ => _.name === "WorldAnvil.Agnoia")
            const waStormvloed = appState.configurations.find(_ => _.name === "WorldAnvil.Stormvloed");

            const agnoiaSpelersHandboek = appState.configurations.find(_ => _.name === "Links.Agnoia.SpelersHandboek");

            setLinks( {
                rules:rulesConfig?.configValue,
                larptomRules:larptomRulesConfig?.configValue,
                otherDocuments:otherDocumentsConfig?.configValue,
                rulesAgnoia: rulesAgnoiaConfig?.configValue,
                otherDocumentsAgnoia: otherDocumentsAgnoiaConfig?.configValue,
                waAgnoia:waAgnoia?.configValue,
                waStormvloed: waStormvloed?.configValue,
                agnoiaSpelersHandboek: agnoiaSpelersHandboek?.configValue
            })
        }
    }, [appState.configurations])

      function handleChangeSelectStory(value) {

        const selectedStory = appState.stories.find(story => story.id === value)
        AppDispatch({ type: "SETSTORYID", payload: {storyId:value, storyName:selectedStory.name} })
        localStorage.setItem('LarpTOM.StoryId', value);
        localStorage.setItem('LarpTOM.StoryName', selectedStory.name);
      }

      const storieOptions = appState.stories.map(story => {
        if(story.name === "Zivania" && !appState.user.isAdmin) {
          return null;
        }
        return (<Option 
          value={story.id} 
          key={story.id}
        >
          {story.name}
        </Option>)
      })

      if(appState.storyName !== "Stormvloed") {
        if  (appState.storyName !== "Agnoia")
            return (
            <>
                <p>The Wiki is only created for Stormvloed and Agnoia Unwritten. </p>
                    <Mobile>
                        <Select 
                            onChange={handleChangeSelectStory}
                            value={parseInt(appState.storyId)}
                            >
                                {storieOptions} 
                        </Select>
                    </Mobile>
                </>
        )
    }

    return (
        <>
          <Tabs defaultActiveKey="1">
                      <TabPane tab="Skills" key="5">
                          <SkillWiki />
                      </TabPane>
                      <TabPane tab={isStormvloed ? "Race" : "World"} key="6">
                          <RaceWiki />
                      </TabPane>
                      {isAgnoia &&
                      <TabPane tab="Items" key="7">
                          <AgnoiaItemWiki />
                      </TabPane>}
                      {isAgnoia &&
                      <TabPane tab="Alchemy" key="8">
                          <AgnoiaAlchemyWiki />
                      </TabPane>}
                      
                      <TabPane tab="Links" key="9">
                          <>
                              {isStormvloed &&
                              <>
                              <a target='_blank' rel="noopener noreferrer" href={links.rules}>
                                  Rules
                              </a>
                              <br />
                              </>}
                              {isAgnoia &&
                              <>
                              <a target='_blank' rel="noopener noreferrer" href={links.rulesAgnoia}>
                                  Rules
                              </a>
                              <br />
                              </>}
                              <a target='_blank' rel="noopener noreferrer" href={links.larptomRules}>
                                  Algemene regels
                              </a>
                              <br />
                              {isStormvloed && 
                              <><a target='_blank' rel="noopener noreferrer" href={links.waStormvloed}>
                                  World anvil (lore)
                              </a>
                              <br />
                              </>}
                              {isAgnoia && <><a target='_blank' rel="noopener noreferrer" href={links.waAgnoia}>
                                  World anvil (lore)
                              </a>
                              <br />
                              </>}
                              {isAgnoia && <><a target='_blank' rel="noopener noreferrer" href={links.agnoiaSpelersHandboek}>
                                  Spelers handboek
                              </a>
                              <br />
                              </>}
                              {isStormvloed && <a target='_blank' rel="noopener noreferrer" href={links.otherDocuments}>
                                  Andere documenten
                              </a>}
                              {isAgnoia && <a target='_blank' rel="noopener noreferrer" href={links.otherDocumentsAgnoia}>
                                  Andere documenten
                              </a>}


                              
                          </>
                      </TabPane>
          </Tabs>
        </>
      )
  }
  
  